import { cn } from "@/lib/utils";
import { useId } from "react";

const SIZES = {
    xs: "size-6",
    sm: "size-8 shadow-[0_10px_30px_-5px_rgba(139,92,246,0.4)]",
    md: "size-10 shadow-[0_12px_38px_-6px_rgba(139,92,246,0.4)]",
    lg: "size-[72px] shadow-[0_18px_48px_-10px_rgba(139,92,246,0.5)]",
};

interface AssistantLogoProps {
    size: keyof typeof SIZES;
    className?: string;
}

const AssistantLogo = ({ size, className }: AssistantLogoProps) => {
    const id = useId().replace(/:/g, "");
    const baseId = `${id}-base`;
    const tintId = `${id}-tint`;

    return (
        <svg
            aria-hidden
            className={cn("flex-none rounded-full", SIZES[size], className)}
            fill="none"
            viewBox="50 30 64 64"
        >
            <defs>
                <linearGradient
                    gradientUnits="userSpaceOnUse"
                    id={baseId}
                    x1="50"
                    x2="114"
                    y1="30"
                    y2="94"
                >
                    <stop stopColor="#8B5CF6" />
                    <stop offset="1" stopColor="#A78BFA" />
                </linearGradient>
                <linearGradient
                    gradientUnits="userSpaceOnUse"
                    id={tintId}
                    x1="117.586"
                    x2="43.7302"
                    y1="30"
                    y2="38.316"
                >
                    <stop stopColor="#925AFF" />
                    <stop offset="1" stopColor="#43006C" />
                </linearGradient>
            </defs>
            <circle cx="82" cy="62" fill={`url(#${baseId})`} r="32" />
            <circle
                cx="82"
                cy="62"
                fill={`url(#${tintId})`}
                opacity="0.3"
                r="32"
            />
            <path
                d="M99.9935 68.3461C99.695 68.464 99.3669 68.5393 98.9897 68.5393C98.8289 68.5393 98.6616 68.5262 98.4943 68.5C97.9728 68.4182 97.5331 67.3468 97.2509 65.4794L95.9028 56.5058C95.3582 52.8692 93.4489 51.5719 91.848 51.5719C89.2336 51.5719 86.3369 54.812 83.2137 61.217C83.2204 59.0908 83.1744 57.3183 82.9579 55.8866C82.4789 52.7054 80.7666 51.5719 79.3232 51.5719C78.1979 51.5719 77.1679 51.9224 76.269 52.6137C74.7436 53.7669 71.7223 56.9121 68.5303 62.2294C68.8814 59.746 69.3833 56.6893 70.0755 53.3181L70.2526 52.4597L66.4801 50.874L66.1422 52.0273C64.9087 56.2503 64.0886 63.1041 64.0066 69.9088L64 70.3871L66.9459 73.0867L67.6249 71.9761C68.0908 71.2127 68.5697 70.3543 69.1241 69.3617C70.8169 66.3312 73.1329 62.1802 76.8628 57.7737C77.9552 56.4927 78.5785 56.0177 78.8442 55.8473C78.8672 55.9489 78.8967 56.0963 78.9295 56.3093C79.2444 58.3995 79.228 61.4332 79.2116 64.6439C79.2018 66.4426 79.1919 68.3035 79.2379 70.1546L79.251 70.6394L82.2494 73.126L82.8366 71.8681C83.2336 71.0129 83.637 70.1021 84.0569 69.1422C85.2871 66.3541 86.678 63.1926 88.6626 59.8967C90.047 57.6001 91.1164 56.3519 91.6282 55.8997C91.7234 56.0865 91.8579 56.4665 91.9661 57.184L93.2455 65.6956C93.9311 70.2692 95.696 72.5887 98.4878 72.5887H98.8749C99.1307 72.5887 99.5212 72.5887 100 72.5232V68.3493L99.9935 68.3461Z"
                fill="white"
            />
        </svg>
    );
};

export default AssistantLogo;
